export const composeRoomParams = (rooms) => {
    let url = '';
    let totalAdults = 0;
    let totalKids = 0;
    let totalInfants = 0;
    rooms.forEach((room, i) => {
        const adults = room.adults;
        url += `;roomAdults${i}=${adults}`;
        totalAdults += adults;
        let indexKids = 0;
        let indexInfants = 0;
        room.kids.forEach((age) => {
            let type = '';
            let numKid = 0;
            if (age < 2) {
                type = 'Infant';
                totalInfants++;
                numKid = indexInfants;
                indexInfants++;
            } else {
                type = 'Kid';
                totalKids++;
                numKid = indexKids;
                indexKids++;
            }
            url += `;room${i}${type}${numKid}Age=${age}`;
        });
    });
    if (totalAdults > 0) {
        url += `;adults=${totalAdults}`;
    }
    if (totalKids > 0) {
        url += `;children=${totalKids}`;
    }
    if (totalInfants > 0) {
        url += `;infants=${totalInfants}`;
    }
    return url;
};
